<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Change Log</h4>
    <fh-refresh-button [refresh]="refreshData" />
  </div>

  <fh-filter-bar (resetFilters)="onResetFilters()">
    <mat-form-field appearance="outline" class="table-field">
      <mat-label>Table</mat-label>
      <input
        matInput
        [value]="entityTable()"
        (input)="entityTable.set($any($event.target).value)"
        (keyup.enter)="onEntityTableChange(entityTable())"
        placeholder="e.g. orders, users..."
      />
      <button matSuffix mat-icon-button (click)="onEntityTableChange(entityTable())">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <fh-form-autocomplete
      [options]="actionOptions"
      label="Action"
      [placeholder]="'Select action...'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="actionFilterFormControl"
      (selectionChange)="onActionChange($any($event))"
    />

    <fh-form-autocomplete
      [options]="actorTypeOptions"
      label="Role"
      [placeholder]="'Select role...'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="actorTypeFilterFormControl"
      (selectionChange)="onActorTypeChange($any($event))"
    />

    <mat-form-field appearance="outline" class="admin-field">
      <mat-label>Changed By</mat-label>
      <input
        matInput
        [value]="adminEmail()"
        (input)="adminEmail.set($any($event.target).value)"
        (keyup.enter)="onAdminEmailChange(adminEmail())"
        placeholder="Admin email..."
      />
      <button matSuffix mat-icon-button (click)="onAdminEmailChange(adminEmail())">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <fh-date-range-filter label="Date Range" (dateRangeChange)="onDateRangeChange($event)" />
  </fh-filter-bar>

  <div class="sgt-note">
    <mat-icon>schedule</mat-icon>
    All times shown in SGT
  </div>

  <fh-data-table
    [config]="tableConfig()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (pageChange)="onPageChange($event)"
  />
</div>
